var map = {
	"./0.5.png": 671,
	"./0.png": 298,
	"./1-2.png": 299,
	"./1.png": 300,
	"./10.png": 309,
	"./11.png": 310,
	"./12.png": 311,
	"./13.png": 312,
	"./14.png": 313,
	"./15.png": 314,
	"./16.png": 315,
	"./17.png": 316,
	"./18.png": 317,
	"./19.png": 318,
	"./2.png": 301,
	"./20.png": 319,
	"./3.png": 302,
	"./4.png": 303,
	"./5.png": 304,
	"./6.png": 305,
	"./7.png": 306,
	"./8.png": 307,
	"./9.png": 308,
	"./G1-2-red.png": 672,
	"./G1-2.png": 673,
	"./G1.png": 674,
	"./G10.png": 675,
	"./G2.png": 676,
	"./G3.png": 677,
	"./G4.png": 678,
	"./G5.png": 679,
	"./G6.png": 680,
	"./G7.png": 681,
	"./G8.png": 682,
	"./G9.png": 683,
	"./Lruler.png": 684,
	"./Lsign.png": 685,
	"./Nsign.png": 686,
	"./Seen-Sign.png": 687,
	"./alternate_rotate.png": 688,
	"./annotations/big/eval/1.png": 689,
	"./annotations/big/eval/2.png": 690,
	"./annotations/big/eval/3.png": 691,
	"./annotations/big/eval/4.png": 692,
	"./annotations/big/eval/5.png": 693,
	"./annotations/big/eval/6.png": 694,
	"./annotations/big/eval/7.png": 695,
	"./annotations/big/eval/comment.png": 696,
	"./annotations/big/mod/1.png": 697,
	"./annotations/big/mod/2.png": 698,
	"./annotations/big/mod/3.png": 699,
	"./annotations/big/mod/4.png": 700,
	"./annotations/big/mod/5.png": 701,
	"./annotations/big/mod/6.png": 702,
	"./annotations/big/mod/7.png": 703,
	"./annotations/big/mod/comment.png": 704,
	"./annotations/blue.png": 705,
	"./annotations/red.png": 706,
	"./annotations/small/eval/1.png": 707,
	"./annotations/small/eval/2.png": 708,
	"./annotations/small/eval/3.png": 709,
	"./annotations/small/eval/4.png": 710,
	"./annotations/small/eval/5.png": 711,
	"./annotations/small/eval/6.png": 712,
	"./annotations/small/eval/7.png": 713,
	"./annotations/small/mod/1.png": 714,
	"./annotations/small/mod/2.png": 715,
	"./annotations/small/mod/3.png": 716,
	"./annotations/small/mod/4.png": 717,
	"./annotations/small/mod/5.png": 718,
	"./annotations/small/mod/6.png": 719,
	"./annotations/small/mod/7.png": 720,
	"./answer-paper.png": 721,
	"./c1-2.png": 722,
	"./c1.png": 723,
	"./c10.png": 724,
	"./c2.png": 725,
	"./c3.png": 726,
	"./c4.png": 727,
	"./c5.png": 728,
	"./c6.png": 729,
	"./c7.png": 730,
	"./c8.png": 731,
	"./c9.png": 732,
	"./cmt.png": 733,
	"./comment.png": 734,
	"./comment.svg": 735,
	"./complete_timer.png": 736,
	"./draft.png": 737,
	"./drawing.png": 738,
	"./drawing_mask.png": 739,
	"./graph.png": 740,
	"./graph_mask.png": 741,
	"./left.svg": 742,
	"./masked.png": 743,
	"./message.png": 744,
	"./mouse-1.png": 659,
	"./mouse.jpeg": 745,
	"./new_offline.gif": 746,
	"./nonset_timer.png": 747,
	"./offline.gif": 748,
	"./online.gif": 749,
	"./paper.png": 750,
	"./paper_side.png": 751,
	"./paper_top.png": 752,
	"./pred.png": 753,
	"./protractor.png": 754,
	"./que_ans.png": 755,
	"./question.png": 660,
	"./reject.png": 756,
	"./right.svg": 757,
	"./rotate.png": 758,
	"./ruler.png": 759,
	"./tringale.png": 760,
	"./truler.png": 761,
	"./write.png": 297,
	"./wrong.png": 762,
	"./x.png": 296,
	"./x2000.png": 763,
	"./x_1.png": 764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670;